import { render, staticRenderFns } from "./PieCategory.vue?vue&type=template&id=c38f14cc&scoped=true"
import script from "./PieCategory.vue?vue&type=script&lang=js"
export * from "./PieCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38f14cc",
  null
  
)

export default component.exports